import { Ellipsis } from "lucide-react";
import React from "react";

import { IgIconButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { MessageBoxWidgetDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { useDispatch } from "@src/store";
import { setDialog } from "@src/store/slices/global";
import { closeWidget, editWidget } from "@src/store/slices/widgets";

interface MessageBoxWidgetPreviewProps {
  widget: MessageBoxWidgetDto;
  library?: boolean;
  children?: React.ReactNode;
}

export const MessageBoxWidgetPreview = ({
  widget,
  children,
}: MessageBoxWidgetPreviewProps) => {
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(editWidget(widget));
  };

  return (
    <Grid
      item
      container
      xs={12}
      md={12}
      lg={6}
      key={widget.id}
      display={"inline-flex"}
    >
      <IgPaper
        sx={{
          padding: "30px 40px",
          width: "100%",
        }}
      >
        <Grid item container direction={"column"} rowSpacing={4}>
          <Grid
            item
            justifyContent={"space-between"}
            container
            alignItems={"center"}
            direction={"row"}
            wrap={"nowrap"}
          >
            <Grid item xs={12}>
              <IgTypography variant={"body1"} fontWeight={400}>
                {widget.name}
              </IgTypography>
            </Grid>
            <Grid item container justifyContent={"flex-end"}>
              <Grid item>
                <IgIconButton iconSize={16} onClick={handleEdit}>
                  <Ellipsis />
                </IgIconButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction={"column"}
            justifyContent={"space-between"}
            rowSpacing={5}
          >
            {children}
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
